import React from 'react';

const Hero = () => {
  return (
    <section
      id="hero"
      className="min-h-screen flex flex-col justify-center px-6 md:px-12 max-w-6xl mx-auto pt-24 md:pt-20"
    >
      <div className="space-y-6 md:space-y-8 max-w-3xl animate-fade-up mt-10 md:mt-0">
        <p className="font-mono text-xs md:text-sm tracking-widest text-neutral-500 dark:text-neutral-400 uppercase">
          Étudiant en ingénierie logicielle
        </p>
        <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold tracking-tight text-neutral-900 dark:text-white leading-tight">
          Création de solutions <br className="hidden sm:block" />
          modernes et performantes.
        </h1>
        <p className="text-lg md:text-xl text-neutral-600 dark:text-neutral-400 max-w-xl leading-relaxed">
          Je suis étudiant en troisième année de développement web et logiciel, spécialisé
          dans la création d’applications propres, scalables, avec un fort accent
          sur les technologies web modernes.
        </p>
        <div className="pt-6 md:pt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-4 md:gap-6">
          <a
            href="#projects"
            className="px-6 md:px-8 py-4 bg-neutral-900 text-white dark:bg-white dark:text-black font-semibold tracking-wide hover:bg-neutral-800 dark:hover:bg-neutral-200 transition-colors duration-200 text-center"
          >
            Voir mes projets
          </a>
          <a
            href="#contact"
            className="px-6 md:px-8 py-4 border border-neutral-300 dark:border-white/20 text-neutral-900 dark:text-white font-semibold tracking-wide hover:bg-neutral-100 dark:hover:bg-white/5 transition-colors duration-200 text-center"
          >
            Me contacter
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;